import { RatingRangeId } from "./DeptDistribution";

// 25  ["AAA",  "AAA"],
// 24  ["Aa1",  "AA+"],
// 23  ["Aa2",  "AA"],                 ↑↑↑
// 22  ["Aa3",  "AA-"],    <---------- "great"
// 21  ["A1",   "A+"],     <--------+
// 20  ["A2",   "A"],               +- "good"
// 19  ["A3",   "A-"],     <--------+
// 18  ["Baa1", "BBB+"],   <--------+
// 17  ["Baa2", "BBB"],             +- "okay"
// 16  ["Baa3", "BBB-"],   <--------+
// 15  ["Ba1",  "BB+"],    <---------- "bad"
// 14  ["Ba2",  "BB"],                 ↓↓↓
// 13  ["Ba3",  "BB-"],
// 12  ["B1",   "B+"],
// 11  ["B2",   "B"],
// 10  ["B3",   "B-"],
//  9  ["Caa1", "CCC+"],
//  8  ["Caa2", "CCC"],
//  7  ["Caa3", "CCC-"],
//  6  ["Ca1",  "CC+"],
//  5  ["Ca2",  "CC"],
//  4  ["Ca3",  "CC-"],
//  3  ["C1",   "C+"],
//  2  ["C2",   "C"],
//  1  ["C3",   "C-"],
//  0  ["D",    "D"],

//   bad: "<BBB-",
//   okay: "BBB",
//   good: "A- to A+",
//   great: "AA- to AAA",

export function getRatingRange(i: number): RatingRangeId {
  if (i >= 22 && i <= 25) {
    return "great";
  }
  if (i >= 19 && i <= 21) {
    return "good";
  }
  if (i >= 16 && i <= 18) {
    return "okay";
  }
  if (i >= 0 && i <= 15) {
    return "bad";
  }

  throw Error(`Invalid index: ${i} for getRatingRange()`);
}
